<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        {{ title }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        message: null,
        title: 'Loading',
        options: {
          color: 'primary',
          width: 290
        }
      }
    },
    methods: {
      open (title, message, options) {
        this.dialog = true
        this.title = title
        this.message = message
        this.options = Object.assign(this.options, options)
        return this.close
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>

<style scoped lang="scss">
.v-dialog__content {
  
}
::v-deep .border-radius {
  border-radius: 13px!important;
}
</style>
